export default class RuleType
{
	static TYPE_0 = 0;
	static TYPE_1 = 1;
	static TYPE_2 = 2;
}